/**
 * Rack Preset API Service
 * Handles all API calls for Rack Presets (Ball-Editor-Admin feature)
 */
import apiClient from '../apiClient';

const BASE_URL = '/api/rack-presets';

/**
 * Get all rack presets
 */
export const getRackPresets = async () => {
  const response = await apiClient.get(`${BASE_URL}/`);
  return response.data;
};

/**
 * Get rack presets by ball set type
 * @param {string} ballSet - 'universal', '9-ball', '10-ball', '8-ball', 'snooker'
 */
export const getRackPresetsByBallSet = async (ballSet) => {
  const response = await apiClient.get(`${BASE_URL}/by_ball_set/`, {
    params: { ball_set: ballSet }
  });
  return response.data;
};

/**
 * Get single rack preset by ID
 */
export const getRackPreset = async (id) => {
  const response = await apiClient.get(`${BASE_URL}/${id}/`);
  return response.data;
};

/**
 * Create new rack preset (Ball-Editor-Admin only)
 */
export const createRackPreset = async (presetData) => {
  const response = await apiClient.post(`${BASE_URL}/`, presetData);
  return response.data;
};

/**
 * Update rack preset (Ball-Editor-Admin only)
 */
export const updateRackPreset = async (id, presetData) => {
  const response = await apiClient.put(`${BASE_URL}/${id}/`, presetData);
  return response.data;
};

/**
 * Delete rack preset (Ball-Editor-Admin only)
 */
export const deleteRackPreset = async (id) => {
  const response = await apiClient.delete(`${BASE_URL}/${id}/`);
  return response.data;
};
